// DropdownPill.jsx
import React, { useEffect, useRef, useState } from "react";

export default function DropdownPill({
  options = [], // [{label, value}]
  value, // current value (we'll pass selectedTab index)
  onChange = () => {}, // (val) => void
  placeholder = "Select",
  className = "",
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const menuRef = useRef(null);

  const selected = options.find((o) => o.value === value);

  useEffect(() => {
    const onClick = (e) => {
      if (
        !btnRef.current?.contains(e.target) &&
        !menuRef.current?.contains(e.target)
      )
        setOpen(false);
    };
    const onEsc = (e) => e.key === "Escape" && setOpen(false);
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, []);

  return (
    <div className={`relative inline-block ${className}`}>
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="min-w-[200px] w-full px-3 py-2 rounded-md bg-[#F9FAFB] text-[#0B1C33]
                   font-medium flex items-center justify-between gap-6 border-[1px] border-[#E4E4E7] focus:outline-none"
      >
        <span className="truncate">{selected?.label ?? placeholder}</span>
        <svg
          className={`w-5 h-5 transition-transform flex-shrink-0 ${open ? "rotate-180" : ""}`}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 8l4 4 4-4"
            stroke="#6B7280"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {open && (
        <div
          ref={menuRef}
          className="absolute z-30 mt-2 w-full min-w-[200px] rounded-2xl bg-white shadow-lg overflow-hidden"
        >
          <ul className="max-h-60 overflow-y-auto">
            {options.map((opt) => (
              <li key={opt.value}>
                <button
                  type="button"
                  onClick={() => {
                    onChange(opt.value);
                    setOpen(false);
                  }}
                  className={`w-full text-left px-4 py-2 text-sm
                    ${
                      value === opt.value
                        ? "bg-[#E17954] font-medium text-[#fff]"
                        : "hover:bg-[#E17954] hover:text-[#fff]"
                    }`}
                >
                  {opt.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
